import { LOGO_URL } from "@/constants/branding";

/**
 * Branded avatar placeholder used when a leader has no photo.
 * Uses royal blue + gold gradient with the CLBC logo watermark and initials.
 */
export default function LeaderAvatar({ name, className = "" }) {
  const initials = (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  return (
    <div
      className={`relative w-full h-full flex items-center justify-center overflow-hidden ${className}`}
      aria-label={name}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-royal-700 via-royal to-royal-800" />
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage: `radial-gradient(circle at 30% 30%, rgba(212,175,55,0.55), transparent 60%)`,
        }}
      />
      <img
        src={LOGO_URL}
        alt=""
        className="absolute right-4 bottom-4 w-16 h-16 rounded-full ring-2 ring-gold/60 opacity-70"
      />
      <div className="relative text-center px-4">
        <div className="font-serif text-6xl text-gold tracking-tight drop-shadow-lg">{initials}</div>
        <div className="mt-2 text-[10px] tracking-[0.35em] uppercase text-white/70">Christ Love Breed</div>
      </div>
    </div>
  );
}
